export const zIndex = {
  modal: 103,
  drawer: 102,
  profile: 101,
  header: 100,
  subHeader: 99,
  overlay_searchbar: 98,
  categoryPicker: 97,
};
